import React from 'react';
import Card from 'react-bootstrap/Card';

import Header from './header';
import Pane from './pane';
import withNameInput from './hoc-input';
import withNameDatepicker from './hoc-datepicker';
import withNameSelect from './hoc-select';
import withNameTextarea from './hoc-textarea';

const ManagementFee = withNameInput('managementFee', 'Management Fee');
const PerformanceFeeCharged = withNameSelect('performanceFeeCharged');
const PerformanceFeePds = withNameInput('performanceFeePds', 'Performance Fee');
const PerformanceFee = withNameInput('performanceFee', 'Actual Performance Fee');
const PerformanceFeeMethodology = withNameTextarea('performanceFeeMethodology', 'Performance Fee Methodology');
const TotalCostRatio = withNameInput('totalCostRatio', 'Total Cost Ratio');
const FinancialYearEndFeesDate = withNameDatepicker('financialYearEndFeesDate', 'Financial Year End Fees Date');

const BuySpread = withNameInput('buySpread', 'Buy Spread');
const SellSpread = withNameInput('sellSpread', 'Sell Spread');
const PDSFeesDate = withNameDatepicker('pdsFeesDate', 'PDS Fees Date');
const LatestProspectusDate = withNameDatepicker('latestProspectusDate', 'Prospectus Date');
const DayEndEntryPrice = withNameInput('dayEndEntryPrice', 'Day End Entry Price');
const DayEndExitPrice = withNameInput('dayEndExitPrice', 'Day End Exit Price');
const DayEndNavPrice = withNameInput('dayEndNavPrice', 'Day End NAV Price');
const DayEndPricingUpdateDate = withNameDatepicker('dayEndPricingUpdateDate', 'Day End Pricing Update Date');
const DayEndMarketPrice = withNameInput('dayEndMarketPrice', 'Day End Market Price');
const DayEndMarketPriceDate = withNameDatepicker('dayEndMarketPriceDate', 'Day End Market Price Date');
const DayEndNav = withNameInput('dayEndNav', 'Day End NAV');
const DayEndNavDate = withNameDatepicker('dayEndNavDate', 'Day End NAV Date');

export default function FundFees() {
  const event = 'fees';

  return (
    <Card>
      <Card.Header>
        <Header eventKey={event}>Fund Fees</Header>
      </Card.Header>
      <Pane eventKey={event}>
        <Card.Body>
          <ManagementFee />
          <PerformanceFeeCharged />
          <PerformanceFeePds />
          <PerformanceFee />
          <PerformanceFeeMethodology />
          <TotalCostRatio />
          <FinancialYearEndFeesDate />
          <BuySpread />
          <SellSpread />
          <PDSFeesDate />
          <LatestProspectusDate />
          <DayEndEntryPrice />
          <DayEndExitPrice />
          <DayEndNavPrice />
          <DayEndPricingUpdateDate />
          <DayEndMarketPrice />
          <DayEndMarketPriceDate />
          <DayEndNav />
          <DayEndNavDate />
        </Card.Body>
      </Pane>
    </Card>
  );
}
